@if (isLoading) {
    <section class="content d-flex justify-content-center align-items-center">
        <mat-spinner diameter="36" />
    </section>
} @else {
    <app-information-collector-by-payment [stepperOn]="false" />
}
